// Mock data for ACTIWA WhatsApp Business Automation platform

export const BRAND = {
  name: 'ACTIWA',
  handle: '@actiwa.io',
  domain: 'www.actiwa.io',
  phone: '7062341111',
  email: 'actiwaio@gmail.com',
  tagline: 'Business Communication, Reimagined.',
  description:
    "AI-powered WhatsApp automation that helps you engage, convert and grow.",
};

export const SIGNUP_URL = 'https://autobot.actiwa.io';
export const WHATSAPP_URL = 'https://wa.me/917062341111';

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/actiwa.io/',
  facebook: 'https://www.facebook.com/actiwaconnect',
  linkedin: 'https://www.linkedin.com/company/actiwa-io/',
  email: 'mailto:actiwaio@gmail.com',
  whatsapp: 'https://wa.me/917062341111',
};

export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  {
    label: 'Features',
    to: '/features',
    children: [
      { label: 'AI Chatbot', to: '/features#ai-chatbot' },
      { label: 'Shared Team Inbox', to: '/features#inbox' },
      { label: 'Broadcast Campaigns', to: '/features#broadcast' },
      { label: 'Smart Automation', to: '/features#automation' },
      { label: 'Analytics & Reports', to: '/features#analytics' },
    ],
  },
  {
    label: 'Integrations',
    to: '/integrations',
  },
  {
    label: 'Solutions',
    to: '/solutions',
    children: [
      { label: 'E-commerce', to: '/solutions#ecommerce' },
      { label: 'Education', to: '/solutions#education' },
      { label: 'Real Estate', to: '/solutions#realestate' },
      { label: 'Healthcare', to: '/solutions#healthcare' },
    ],
  },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Demo', to: '/demo' },
  {
    label: 'Resources',
    to: '/contact',
    children: [
      { label: 'Contact Us', to: '/contact' },
      { label: 'Book a Demo', to: '/demo' },
    ],
  },
];

export const HERO_STATS = [
  { value: '500+', label: 'Happy Businesses' },
  { value: '24K+', label: 'Conversations Daily' },
  { value: '99.9%', label: 'Uptime' },
  { value: '24/7', label: 'AI Support' },
];

export const HOW_IT_WORKS = [
  {
    step: '01',
    title: 'Lead Comes In',
    desc: 'Customer sends a message on WhatsApp or other channels.',
    tags: ['WhatsApp API', 'Multi-channel'],
  },
  {
    step: '02',
    title: 'AI Replies Instantly',
    desc: "ACTIWA's AI chatbot answers in seconds and engages 24/7.",
    tags: ['AI Powered', 'Instant reply'],
  },
  {
    step: '03',
    title: 'Team Joins In',
    desc: 'Conversations are assigned, noted and collaborated.',
    tags: ['Shared Inbox', 'Team Collab'],
  },
  {
    step: '04',
    title: 'Customer Converts',
    desc: 'Faster responses. Better experience. More sales.',
    tags: ['Higher conversion', 'Better CX'],
  },
  {
    step: '05',
    title: 'Follow-up & Retain',
    desc: 'Automated follow-ups build trust and turn buyers into loyal customers.',
    tags: ['Drip Campaigns', 'Retention'],
  },
];

export const FEATURES = [
  {
    id: 'ai-chatbot',
    title: 'AI Chatbot',
    tagline: 'Instant smart replies',
    desc: 'Train an AI chatbot on your business data for intelligent, context-aware responses. Let AI handle customer queries 24/7 while you focus on growing your business.',
    bullets: [
      'Train with your own knowledge base',
      'Natural language understanding',
      '24/7 automated responses',
      'Seamless human handoff',
    ],
    image:
      'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=900&auto=format&fit=crop',
  },
  {
    id: 'inbox',
    title: 'Shared Team Inbox',
    tagline: 'Teamwork made seamless',
    desc: "ACTIWA's shared team inbox enables seamless collaboration using a single WhatsApp Business Number. Quick replies, real-time notifications and mobile-friendly interface ensure prompt customer service.",
    bullets: [
      'Add multiple team members easily',
      'Assign chats to specific agents',
      'Protect customer privacy with number masking',
      'Send text, media and voice messages',
    ],
    image:
      'https://images.unsplash.com/photo-1552664730-d307ca884978?w=900&auto=format&fit=crop',
  },
  {
    id: 'broadcast',
    title: 'Broadcast Campaigns',
    tagline: 'Reach more. Convert more.',
    desc: 'Reach thousands of customers instantly with personalized bulk messages. Schedule campaigns, segment your audience and track delivery in real-time with powerful broadcasting tools.',
    bullets: [
      'Send to unlimited contacts at once',
      'Personalize with dynamic variables',
      'Schedule broadcasts in advance',
      'Track delivery and read rates',
    ],
    image:
      'https://images.unsplash.com/photo-1611926653458-09294b3142bf?w=900&auto=format&fit=crop',
  },
  {
    id: 'automation',
    title: 'Smart Automation',
    tagline: 'Workflows on autopilot',
    desc: 'Connect apps and trigger messages based on events. Automate repetitive tasks and create sophisticated workflows without coding.',
    bullets: [
      'Event-based triggers',
      'Visual workflow builder',
      'Conditional logic support',
      'Connect 1000+ apps',
    ],
    image:
      'https://images.unsplash.com/photo-1518770660439-4636190af475?w=900&auto=format&fit=crop',
  },
  {
    id: 'analytics',
    title: 'Analytics & Reports',
    tagline: 'Data that helps you grow',
    desc: 'Track performance in real-time and make data-driven decisions. Understand what works and optimize your campaigns for better ROI.',
    bullets: [
      'Real-time dashboards',
      'Campaign performance reports',
      'Team productivity metrics',
      'Export data anytime',
    ],
    image:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900&auto=format&fit=crop',
  },
  {
    id: 'crm',
    title: 'CRM Integration',
    tagline: 'Sync every lead',
    desc: 'Integrate with your favorite tools and sync every lead. Keep customer data updated across systems automatically.',
    bullets: [
      'Two-way CRM sync',
      'Custom fields mapping',
      'Lead scoring',
      'Sales pipeline integration',
    ],
    image:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=900&auto=format&fit=crop',
  },
];

export const PREMIUM_FEATURES = [
  { title: 'High Speed Broadcasting', desc: 'Send thousands of messages per minute with our optimized broadcasting engine.', popular: true },
  { title: 'Campaign Retry', desc: 'Automatically retry failed messages to ensure maximum delivery rates.' },
  { title: 'Bulk Subscriber Import', desc: 'Import thousands of contacts from CSV, Excel or CRM.' },
  { title: 'Carousel Templates', desc: 'Create stunning multi-card carousel messages to showcase products.', popular: true },
  { title: 'Native WhatsApp Forms', desc: 'Collect data seamlessly with native WhatsApp form experiences.' },
  { title: 'Interactive User Input', desc: 'Collect responses with buttons, lists and quick replies.' },
  { title: 'Powerful APIs', desc: 'Full REST API access to automate and integrate with any system.', popular: true },
  { title: 'Custom Webhook Listener', desc: 'Receive real-time events and trigger actions in your applications.' },
  { title: 'Custom Variables', desc: 'Store and use custom data fields for personalized messaging.' },
  { title: 'Advanced Analytics', desc: 'Deep insights into message performance, engagement and ROI.' },
  { title: 'Smart Labels & Tags', desc: 'Organize contacts with labels for targeted segmentation.' },
  { title: 'Team Permissions', desc: 'Granular role-based access control for your team members.' },
];

export const PLANS = [
  {
    name: '7 Days Free Trial',
    price: '₹0',
    period: '7 Days',
    note: 'No Credit Card Required',
    cta: 'Start Free Trial',
    highlight: false,
    features: [
      'AI Chatbot',
      'Shared Inbox (1 User)',
      'Broadcast (500 messages)',
      'Basic Analytics',
      'Community Support',
      'Contact Management',
      'Template Management',
      'Chat Widget',
    ],
  },
  {
    name: 'Starter',
    price: '₹999',
    period: '/month',
    note: 'Perfect for small businesses getting started',
    cta: 'Get Started',
    highlight: false,
    features: [
      'AI Chatbot',
      'Shared Inbox (1 User)',
      'Broadcast (1,000 / month)',
      'Basic Analytics',
      'Email Support',
      'Contact Management',
      'Template Management',
      'Chat Widget (1 Website)',
    ],
  },
  {
    name: 'Growth',
    price: '₹2,499',
    period: '/month',
    note: 'Everything you need to grow and automate more',
    cta: 'Start 7-Day Free Trial',
    highlight: true,
    tag: 'MOST POPULAR',
    features: [
      'AI Chatbot',
      'Shared Inbox (5 Users)',
      'Broadcast (10,000 / month)',
      'Smart Automation',
      'Advanced Analytics',
      'Priority Support',
      'Drip Campaigns',
      'CRM Integration',
      'Custom Variables',
      'Team Permissions',
    ],
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    note: 'Pricing based on your needs',
    cta: 'Contact Sales',
    highlight: false,
    features: [
      'All Growth Features',
      'Unlimited Users',
      'Unlimited Broadcast',
      'Custom Integrations',
      'Dedicated Account Manager',
      '24/7 Premium Support',
      'SLA Guarantee',
      'Onboarding & Training',
    ],
  },
];

export const INTEGRATIONS = [
  { name: 'Shopify', cat: 'E-Commerce' },
  { name: 'WooCommerce', cat: 'E-Commerce' },
  { name: 'WhatsApp Catalogue', cat: 'E-Commerce' },
  { name: 'Zapier', cat: 'Automation' },
  { name: 'Pabbly Connect', cat: 'Automation' },
  { name: 'Webhook', cat: 'Automation' },
  { name: 'HTTP API', cat: 'Automation' },
  { name: 'Google Sheets', cat: 'Automation' },
  { name: 'Google Forms', cat: 'Forms' },
  { name: 'Form Flows', cat: 'Forms' },
  { name: 'WP Forms', cat: 'Forms' },
  { name: 'Elementor', cat: 'Forms' },
  { name: 'OpenAI', cat: 'AI' },
  { name: 'Mailchimp', cat: 'Marketing' },
  { name: 'Brevo', cat: 'Marketing' },
  { name: 'Mautic', cat: 'Marketing' },
  { name: 'Mandrill', cat: 'Marketing' },
  { name: 'Postmark', cat: 'Marketing' },
  { name: 'Clickatell', cat: 'SMS' },
  { name: 'Nexmo', cat: 'SMS' },
  { name: "Africa's Talking", cat: 'SMS' },
  { name: 'Razorpay', cat: 'Payments' },
  { name: 'Instamojo', cat: 'Payments' },
  { name: 'PhonePe', cat: 'Payments' },
  { name: 'Stripe', cat: 'Payments' },
  { name: 'Mollie', cat: 'Payments' },
  { name: 'Paystack', cat: 'Payments' },
  { name: 'Flutterwave', cat: 'Payments' },
  { name: 'Mercado Pago', cat: 'Payments' },
  { name: 'PayMaya', cat: 'Payments' },
  { name: 'MyFatoorah', cat: 'Payments' },
  { name: 'Tap', cat: 'Payments' },
  { name: 'senangPay', cat: 'Payments' },
  { name: 'ToyyibPay', cat: 'Payments' },
  { name: 'YooMoney', cat: 'Payments' },
];

export const SOLUTIONS = [
  {
    id: 'ecommerce',
    title: 'E-Commerce',
    desc: 'Recover abandoned carts, send order updates and turn WhatsApp into a sales channel.',
    points: ['Abandoned cart recovery', 'Order tracking updates', 'Catalog & payments', 'COD confirmation'],
  },
  {
    id: 'education',
    title: 'Education',
    desc: 'Nurture leads, send fee reminders, share resources and support students 24/7.',
    points: ['Admission automation', 'Fee reminders', 'Class notifications', 'Doubt solving with AI'],
  },
  {
    id: 'realestate',
    title: 'Real Estate',
    desc: 'Capture leads, send property brochures and book site visits directly on WhatsApp.',
    points: ['Lead qualification', 'Auto brochure sharing', 'Site visit booking', 'Follow-up sequences'],
  },
  {
    id: 'healthcare',
    title: 'Healthcare',
    desc: 'Appointment reminders, prescription updates and instant patient support with AI.',
    points: ['Appointment booking', 'Prescription refill', 'Test report delivery', 'Post-care follow-up'],
  },
  {
    id: 'travel',
    title: 'Travel & Hospitality',
    desc: 'Send itineraries, confirmations and 24/7 concierge support powered by AI.',
    points: ['Booking confirmations', 'Itinerary sharing', 'Concierge chatbot', 'Feedback collection'],
  },
  {
    id: 'agency',
    title: 'Marketing Agencies',
    desc: 'Manage multiple clients from a single dashboard with white-label options.',
    points: ['Multi-client dashboard', 'Reseller pricing', 'White-label option', 'Client reporting'],
  },
];

export const TESTIMONIALS = [
  {
    name: 'Rahul Sharma',
    role: 'Founder, TrendyKart',
    text: "ACTIWA transformed our WhatsApp support. We handle 5x more customers with the same team. The AI chatbot is a game changer.",
    initials: 'RS',
  },
  {
    name: 'Neha Verma',
    role: 'Marketing Head, EduPro',
    text: 'Broadcast campaigns delivered 3x higher open rates than email. Our lead-to-admission funnel is now fully automated.',
    initials: 'NV',
  },
  {
    name: 'Aman Singh',
    role: 'CEO, PropertyHub',
    text: 'The shared team inbox with number masking is exactly what we needed. Our agents collaborate faster and deals close quicker.',
    initials: 'AS',
  },
  {
    name: 'Priya Kapoor',
    role: 'Director, HealPlus Clinic',
    text: 'Appointment reminders on WhatsApp reduced our no-show rate by 40%. Patients love the instant support.',
    initials: 'PK',
  },
  {
    name: 'Vikram Joshi',
    role: 'Owner, WanderTrips',
    text: 'The automation workflows saved us 30+ hours per week. ACTIWA pays for itself in the first month.',
    initials: 'VJ',
  },
  {
    name: 'Sneha Iyer',
    role: 'Growth Lead, FinBoost',
    text: 'Onboarded in under an hour. No markup fees. Their support team is incredibly responsive.',
    initials: 'SI',
  },
];

export const FAQS = [
  {
    q: 'What is ACTIWA?',
    a: 'ACTIWA is a complete WhatsApp automation platform that helps businesses manage conversations, build AI chatbots, send broadcasts and automate customer journeys using the Official WhatsApp Business API.',
  },
  {
    q: 'How does ACTIWA help my business?',
    a: 'ACTIWA reduces manual workload by automating replies, capturing leads, sending follow-ups and managing customer support on WhatsApp. Respond faster, stay organized and convert more conversations into customers.',
  },
  {
    q: 'How do I set up ACTIWA?',
    a: "Create an ACTIWA account, connect your WhatsApp number through the WhatsApp Business API Embedded Signup, complete verification and you're ready to build flows, inboxes and campaigns in minutes.",
  },
  {
    q: 'Can I use my existing WhatsApp number?',
    a: 'Yes. Your current WhatsApp number can be migrated to the WhatsApp Business Platform and then connected to ACTIWA. Once migrated, it will work with ACTIWA instead of the mobile app.',
  },
  {
    q: 'Can I create multiple WhatsApp chatbots at no extra cost?',
    a: 'Absolutely. You can build unlimited chatbot flows for different use cases like sales, support, onboarding or lead capture — without paying per bot.',
  },
  {
    q: 'Can I add multiple team members?',
    a: 'Yes. You can add multiple team members and assign conversations, roles and responsibilities. Number of seats depends on your plan.',
  },
  {
    q: 'Do I need to pay Meta separately?',
    a: 'Yes. WhatsApp conversations are billed by Meta as per their pricing model. ACTIWA provides the platform, while Meta charges for message conversations. We do not add any markup.',
  },
  {
    q: 'Can I cancel my subscription anytime?',
    a: 'Yes. You have full control over your subscription and can cancel or change your plan whenever you want. No lock-in contracts.',
  },
];

export const FOOTER_LINKS = {
  Product: [
    { label: 'Features', to: '/features' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Integrations', to: '/integrations' },
    { label: 'Solutions', to: '/solutions' },
    { label: 'Book a Demo', to: '/demo' },
  ],
  Company: [
    { label: 'About Us', to: '/contact' },
    { label: 'Contact', to: '/contact' },
    { label: 'Careers', to: '/contact' },
    { label: 'Partners', to: '/contact' },
  ],
  Resources: [
    { label: 'Help Center', to: '/contact' },
    { label: 'Blog', to: '/contact' },
    { label: 'API Docs', to: '/contact' },
    { label: 'Status', to: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/contact' },
    { label: 'Terms of Service', to: '/contact' },
    { label: 'Refund Policy', to: '/contact' },
    { label: 'GDPR', to: '/contact' },
  ],
};
